import React, { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from '../../components/organisms/Header/Header';

const Layout = () => {
    const location = useLocation();
    const [ismobile, setIsmobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location.pathname])

    return (
        <div className='relative'>
        
            <Outlet />
        </div>
    )
}

export default Layout;
